import React, {useEffect, useState, useRef, useCallback} from "react";
import Dialog from "../lib/Dialog";
import YSF from '@neysf/qiyu-web-sdk';

export default props => {

  const [ysfUrl, setYsfUrl] = useState();

  useEffect(()=>{
    kfservice()
  },[])

  const kfservice = async () => {
    let kf = async () => {
      let cleanupFunction = () => {}; // 默認的清理函數
    
      YSF.init('788a953cb33cf8020c67d822bf6bb88c', {
        templateId: 8140848,
        shuntId: 8140848,
        sessionInvite: false,
        hidden: 1
      }).then(ysf => {
        // 在.then中操作
        ysf('config', {
          connectYunxin: true
        });
    
        ysf('getSessionList', function(result) {
          result = [
            // {
            //   id: 6671521,
            //   lastMessage: {
            //       content: "測試服網頁平臺子企業歡迎語[驚訝]",
            //       fromUser: 0,
            //       time: 1620629768269,
            //       type: "richtext",
            //   },
            //   sessionStatus: {
            //       hasEvaluation: 1,
            //       hasKefuEntry: 0,
            //       status: 200
            //   },
            //   shop: {
            //       id: "ptqy",
            //       logo: "https://hddd6-ptqy.qiyukf.net/e30641a82249cd0a2d9537abd82efa87",
            //       name: "七魚專賣店"
            //   },
            //   startTime: 1620629768091,
            //   endTime: 1620629768091,
            //   unread: 2
            // }
          ]
        });
    
        // ysf('onSessionMessage', function(result) {
        //   console.log(result);
        // });
    
        // ysf('onSessionOpen', function(data) {
        //   window.open('https://example.com/chat/' + data.staffId, '_blank');
        // });
  
        // ysf('onSessionClose', function() {
        //   console.log("關閉了......")
        //   window.close(); // 關閉當前標籤頁
        // });
        // ysf('open', {
        //   bid: "6671521"
        // });
        // ysf('open');
        setYsfUrl(ysf('url'));
        Dialog.close();
      }).catch(error => {
        Dialog.close();
        console.log('sdk加載失敗---', error);
      }).finally(() => {
        Dialog.close();
        console.log('清理資源...');
        cleanupFunction(); // 調用清理函數
      });
    
      // 返回清理函數
      return () => {
        cleanupFunction();
        // 在此處進行其他清理操作
      };
    }

    await kf();
  }

  return <div className="service-infobox" style={{width:'100%',height:'calc(100vh - 40px - env(safe-area-inset-top))'}}>
  {ysfUrl ? 
    <embed src={ysfUrl}
            style={{width:'100%',height:'100%'}}
            className={"ordinary "}
            type="text/html">
          </embed> : null}
  </div>;
};